import VueI18n from 'vue-i18n';
import { getLanguage } from 'packages/utilities/Lang';
import translations from 'common/resources/lang/translations';
import FORMATS from 'config/formats';
import Vue from 'vue';
import { container } from 'tsyringe';
Vue.use(VueI18n);
var i18n = new VueI18n({
    locale: getLanguage(),
    messages: translations,
    fallbackLocale: 'en-GB',
    silentTranslationWarn: true,
    numberFormats: FORMATS.NUMBERS,
});
container.registerInstance(VueI18n, i18n);
export default i18n;
